enum FeatureErrorName {
    BET_LIMIT_EXCEED = 'bet exceed bet limit',
    TABLE_LIMIT_EXCEED = 'bet exceed table limit',
    INSUFFICIENT_BALANCE = 'insufficient balance',
    TABLE_IS_FULL = 'table is full',
    TABLE_IS_CLOSED = 'table is closed',
    TABLE_IS_PREPARING = 'table is preparing',
    NO_TABLE_FOUND = 'no table found',
    WAGER_SHOULD_BE_EXCLUSIVE = 'wager should be exclusive',
    OPERATION_NOT_ALLOWED = 'operate not allow',

    // exit table error
    DEVICE_UNAVAILABLE = 'device unavailable',
    DEVICE_RUN_FAILED = 'device run failed',
    DEVICE_NO_RESULT = 'device no result',
    DEVICE_NOT_READY = 'device not ready',
}

export default FeatureErrorName;
